export const FETCH_PAGES_REQUEST  = 'FETCH_PAGES_REQUEST';
export const FETCH_PAGES_SUCCESS  = 'FETCH_PAGES_SUCCESS';
export const FETCH_PAGES_ERROR    = 'FETCH_PAGES_ERROR';

export const FETCH_CATEGORIES_REQUEST  = 'FETCH_CATEGORIES_REQUEST';
export const FETCH_CATEGORIES_SUCCESS  = 'FETCH_CATEGORIES_SUCCESS';
export const FETCH_CATEGORIES_ERROR    = 'FETCH_CATEGORIES_ERROR';

export const FETCH_PAGEBYID_REQUEST  = 'FETCH_PAGEBYID_REQUEST';
export const FETCH_PAGEBYID_SUCCESS  = 'FETCH_PAGEBYID_SUCCESS';
export const FETCH_PAGEBYID_ERROR    = 'FETCH_PAGEBYID_ERROR';

export const FETCH_PAGEBYPARENT_REQUEST  = 'FETCH_PAGEBYPARENT_REQUEST';
export const FETCH_PAGEBYPARENT_SUCCESS  = 'FETCH_PAGEBYPARENT_SUCCESS';
export const FETCH_PAGEBYPARENT_ERROR    = 'FETCH_PAGEBYPARENT_ERROR';

export const FETCH_PAGEBYSLUG_REQUEST  = 'FETCH_PAGEBYSLUG_REQUEST';
export const FETCH_PAGEBYSLUG_SUCCESS  = 'FETCH_PAGEBYSLUG_SUCCESS';
export const FETCH_PAGEBYSLUG_ERROR    = 'FETCH_PAGEBYSLUG_ERROR';

export const FETCH_POSTS_REQUEST  = 'FETCH_POSTS_REQUEST';
export const FETCH_POSTS_SUCCESS  = 'FETCH_POSTS_SUCCESS';
export const FETCH_POSTS_ERROR    = 'FETCH_POSTS_ERROR';



// WEBPACK FOOTER //
// ./src/store/constants/index.js